"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserGroups = void 0;
var _config = require("../publicAPI/config");
var _constants = require("../publicAPI/constants");
var _store = require("../publicAPI/store");
var _constants2 = _interopRequireDefault(require("../constants"));
var _auth = require("./auth");
const getUserGroups = () => {
  try {
    const connector = (0, _config.getFieldFromMeta)('auth.connector');
    if (connector === _constants2.default.PCAS_CONNECTOR) {
      const session = (0, _store.getSession)();
      const groups = session.attrs.groups;
      return groups;
    }
    if (connector === _constants2.default.MID2_CONNECTOR) {
      const token = sessionStorage.getItem(_constants.COMMON_CONSTANTS.MID_ACCESS_TOKEN_KEY);
      const {
        groups
      } = (0, _auth.parseJWT)(token);
      return groups;
    }
    return null;
  } catch {
    return null;
  }
};
exports.getUserGroups = getUserGroups;